import {
  Box,
  Button,
  Flex,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";
import React from "react";
import { GRAY, WHITE } from "../../../../constants/colors";
import moment from "moment";
import { ToLocaleFormat } from "../../../../defaultFunctions/formaters";

const ViewModalAssinaturas = ({ isOpen, setIsOpen, item }: any) => {
  const finalRef = React.useRef(null);

  // console.log("item: ", item);

  const onClose = () => {
    setIsOpen(false);
  };

  return (
    <>
      <Modal
        finalFocusRef={finalRef}
        isOpen={isOpen}
        onClose={onClose}
        size={"xl"}
      >
        <ModalOverlay backdropFilter="blur(10px)" />
        <ModalContent>
          <ModalHeader>
            <Flex w={"100%"} justifyContent={"center"}>
              <Text fontWeight={"bold"}>Detalhes da Assinatura</Text>
            </Flex>
          </ModalHeader>
          {item && (
            <ModalBody>
              <Flex
                w={"530px"}
                alignItems={"flex-start"}
                h={"250px"}
                flexDirection="column"
                border={"2px solid #c4c4c4"}
                justifyContent={"space-evenly"}
                px={5}
                shadow={"md"}
                borderRadius={"6px"}
              >
                <Text>
                  Cliente:{" "}
                  {item?.cliente?.isCnpj === true
                    ? item?.cliente?.razaoSocial
                    : `${item?.cliente?.nome} ${item?.cliente?.sobrenome}`}
                </Text>
                <Text>Id do Plano: {item?.idPlano}</Text>
                <Text>Nome do Plano: {item?.plano?.nome}</Text>
                <Text>
                  Data da Primeira Cobrança:{" "}
                  {moment(item?.dataProximaCobranca).format("DD/MM/YYYY")}
                </Text>
                <Text>
                  Data de Expiração:{" "}
                  {moment(item?.dataExpiracao).format("DD/MM/YYYY")}
                </Text>
                <Text>Valor: {ToLocaleFormat(item?.valor / 100)}</Text>
                {item?.motivo && <Text>{item.motivo}</Text>}
                {/* <Text>N° da POS: {item?.idPOS}</Text>
                <Text>Código de Verificação: {item?.codigoVerificacao}</Text>
                <Text>Código de Autorização: {item?.codigoAutorizacao}</Text>
                <Text>
                  Data da Transação:{" "}
                  {moment(item?.dataCriacao).format("DD/MM/YYYY HH:MM")}
                </Text> */}
                {/* <Text>
                  Comprovante:{" "}
                  <a
                    style={{ color: VARIANT }}
                    href={`https://api.zoop.ws/v1/receipts/19a37129ff10494ba8f64ea3e9d27ecc/${item?.idPagamento}`}
                    target="_blank"
                  >
                    Clique para visualizar o recibo
                  </a>
                </Text> */}
              </Flex>
            </ModalBody>
          )}

          <ModalFooter justifyContent={"space-evenly"}>
            <Button
              background={GRAY}
              color={WHITE}
              onClick={() => {
                onClose();
              }}
            >
              Fechar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default ViewModalAssinaturas;
